export const EMAIL = 'email';
export const PASSWORD = 'password';
export const OTP_CONTROL = 'otpControl';
